import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const SimpleRightArrowIcon = createIcon({
  displayName: 'SimpleRightArrow',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M10,16l4,-4l-4,-4"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      ></path>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const SimpleRightArrow: FC<IconProps> = (props) => {
  return <CustomIcon as={SimpleRightArrowIcon} {...props} />
}

export default memo(SimpleRightArrow)
